import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

/** Screen 184: Request authorization for job cards that already have invoice(s). */
export const screen_184_jobcard_invoice_auth_request: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Job card invoice authorization – request",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              margin: 0,
              marginBottom: 8,
            },
            childComponents: [],
          },
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "jobcard_no",
            Name: "jobcard_invoice_auth_request_summary",
            apiname: "jobcard_invoice_auth_request_summary",
            BindValue: "grid_jobcard_invoice_auth_request",
            SummeryActions: [
              {
                Action: {
                  Module: "jobcard_invoice_auth",
                },
                ActionType: "request",
                Label: "Request",
                allowRequestReason: true,
                requireRequestReason: true,
                requestReasonLabel: "Reason for job card authorization request",
                confirmMessage:
                  "Submit authorization request for this job card? A reason is required.",
                visibleForStatus: ["not requested", "rejected"],
              },
            ],
            Form: {
              Name: "jobcard_invoice_auth_request_summary",
              TableName: "service_job_card",
              DisplayName: "Request job card authorization",
              View: "view_jobcard_invoice_authorization",
              Filter:
                "view_jobcard_invoice_authorization.soft_delete=0 AND view_jobcard_invoice_authorization.invoice_count > 0 AND view_jobcard_invoice_authorization.status IN ('Not requested', 'Rejected') ORDER BY view_jobcard_invoice_authorization.job_date DESC",
              Workflow: null,
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Job card no.",
                  BindValue: "txt_jobcard_no",
                  Json_Attribute: "jobcard_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Job card date",
                  BindValue: "txt_job_date",
                  Json_Attribute: "job_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Invoice number(s)",
                  BindValue: "txt_invoice_numbers",
                  Json_Attribute: "invoice_numbers",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Invoice count",
                  BindValue: "txt_invoice_count",
                  Json_Attribute: "invoice_count",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Reg. no.",
                  BindValue: "txt_reg_no",
                  Json_Attribute: "reg_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Customer",
                  BindValue: "txt_customer_name",
                  Json_Attribute: "customer_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Request reason",
                  BindValue: "txt_request_reason",
                  Json_Attribute: "request_reason",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Authorization status",
                  BindValue: "txt_status",
                  Json_Attribute: "status",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
